import styled from 'styled-components'
import media from 'styled-media-query'

export const Description = styled.p`
  font-size: 2.2rem;
  font-weight: 300;
  line-height: 32px;
  margin-bottom: var(--space-lg);
`
